import React from 'react';
import { Icon } from '@ab-inbev-maz/compass';
import type { ModalIconType } from '../stores/modalStore';
import type { IconName } from '@ab-inbev-maz/compass/dist/entities/components/icon.js';

interface ModalIconProps {
  type?: ModalIconType;
  iconName?: IconName;
}

const SuccessIcon = () => (
  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#4CAF50" />
  </svg>
);

const ErrorIcon = () => (
  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#F44336" />
  </svg>
);

const WarningIcon = () => (
  <svg width="80" height="80" viewBox="0 0 66 59" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M25.6044 4.78798C27.1722 2.2034 29.9757 0.625 32.9986 0.625C36.0215 0.625 38.825 2.2034 40.401 4.80169L64.8411 45.6032C66.3777 48.2642 66.3868 51.5408 64.8652 54.2104C63.3435 56.88 60.5195 58.5416 57.4152 58.5756L8.55025 58.5754C5.47761 58.5416 2.65364 56.88 1.13197 54.2104C-0.3897 51.5408 -0.380526 48.2642 1.17949 45.5634L25.6044 4.78798ZM35.4633 7.7781C34.9407 6.91657 34.0062 6.39044 32.9986 6.39044C31.9909 6.39044 31.0564 6.91657 30.5421 7.76439L6.14889 48.4862C5.63669 49.3732 5.63363 50.4654 6.14085 51.3553C6.64808 52.2452 7.5894 52.7991 8.58193 52.8101L57.3835 52.8103C58.4077 52.7991 59.3491 52.2452 59.8563 51.3553C60.3635 50.4654 60.3605 49.3732 59.8717 48.526L35.4633 7.7781ZM32.9986 18.2175C34.4769 18.2175 35.6954 19.3303 35.8619 20.764L35.8813 21.1002V32.6311C35.8813 34.2232 34.5907 35.5138 32.9986 35.5138C31.5202 35.5138 30.3018 34.401 30.1352 32.9673L30.1158 32.6311V21.1002C30.1158 19.5081 31.4065 18.2175 32.9986 18.2175ZM35.9101 44.162C35.9101 42.5699 34.6195 41.2793 33.0274 41.2793L32.6624 41.2987C31.2287 41.4652 30.1158 42.6836 30.1158 44.162C30.1158 45.7541 31.4065 47.0447 32.9986 47.0447L33.3636 47.0253C34.7973 46.8588 35.9101 45.6403 35.9101 44.162Z" fill="#FFB042" />
  </svg>
);

const WarningOctagonIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.61273 3H15.3873C15.6043 3 15.8124 3.0862 15.9658 3.23964L20.7604 8.03419C20.9138 8.18762 21 8.39573 21 8.61273V15.3873C21 15.6043 20.9138 15.8124 20.7604 15.9658L15.9658 20.7604C15.8124 20.9138 15.6043 21 15.3873 21H8.61273C8.39573 21 8.18762 20.9138 8.03419 20.7604L3.23964 15.9658C3.0862 15.8124 3 15.6043 3 15.3873V8.61273C3 8.39573 3.0862 8.18762 3.23964 8.03419L8.03419 3.23964C8.18762 3.0862 8.39573 3 8.61273 3ZM19.3636 8.95227L15.0477 4.63636H8.95146L4.63636 8.95146V15.0477L8.95227 19.3636H15.0469L19.3636 15.0469V8.95227ZM12 7.90909C12.4196 7.90909 12.7654 8.22494 12.8127 8.63186L12.8182 8.72727V12C12.8182 12.4519 12.4519 12.8182 12 12.8182C11.5804 12.8182 11.2346 12.5023 11.1873 12.0954L11.1818 12V8.72727C11.1818 8.2754 11.5481 7.90909 12 7.90909ZM12.8264 15.2727C12.8264 14.8209 12.4601 14.4545 12.0082 14.4545L11.9046 14.46C11.4977 14.5073 11.1818 14.8531 11.1818 15.2727C11.1818 15.7246 11.5481 16.0909 12 16.0909L12.1036 16.0854C12.5105 16.0381 12.8264 15.6923 12.8264 15.2727Z" fill="#E4423F" />
  </svg>
);

const InfoIcon = () => (
  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="#2196F3" />
  </svg>
);

const ModalIcon: React.FC<ModalIconProps> = ({ type, iconName }) => {
  if (iconName) {
    return <div className="flex items-center justify-center w-20 h-20 mx-auto text-7xl" data-testid="modal-icon"><Icon name={iconName} /></div>;
  }

  switch (type) {
    case 'success':
      return <div className="flex items-center justify-center w-20 h-20 mx-auto" data-testid="modal-icon"><SuccessIcon /></div>;
    case 'error':
      return <div className="flex items-center justify-center w-20 h-20 mx-auto" data-testid="modal-icon"><ErrorIcon /></div>;
    case 'warning':
      return <div className="flex items-center justify-center w-20 h-20 mx-auto" data-testid="modal-icon"><WarningIcon /></div>;
    case 'warning-octagon':
      return <div className="flex items-center justify-center w-20 h-20 mx-auto" data-testid="modal-icon"><WarningOctagonIcon /></div>;
    case 'info':
      return <div className="flex items-center justify-center w-20 h-20 mx-auto" data-testid="modal-icon"><InfoIcon /></div>;
    default:
      return null;
  }
};

export default ModalIcon;
